import { fetchJsonResponse } from '@/ai/api'
import { buildEntitiesExampleDataPrompt } from '@/ai/prompts'

export const generateEntitiesExampleData = async ({
  aiVersion,
  entities,
  abortController
}) => {
  if (!aiVersion) {
    return null
  }

  const messages = buildEntitiesExampleDataPrompt({ entities })

  const response = await fetchJsonResponse({
    messages,
    useCase: 'entities',
    aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
